module.exports = ".card {\n  display: block;\n  width: 100%;\n  border: 1px solid #eee;\n  border-radius: 5px; }\n  .card .card-header {\n    border-bottom: 1px solid #eee;\n    padding: 15px 25px; }\n  .card .card-header .card-title {\n      font-weight: 500;\n      font-size: 1em;\n      margin: 0;\n      letter-spacing: 0.6px;\n      color: #626262; }\n  .card .card-body {\n    padding: 25px; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/security-guard/security-guard.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/dashboards/pages/security-guard/security-guard.component.scss
// module chunks = main